import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { useAsync } from '@sde/widgets-core/src/redux/hooks/useAsync';
import {
  getOrganizations,
  getTaxIdNumbers,
  getProviders,
  getSavedProvider,
  postSavedProvider,
} from './actions';
import {
  GET_ORGANIZATIONS,
  GET_TAX_ID_NUMBERS,
  GET_PROVIDERS,
  GET_SAVED_PROVIDER,
  POST_SAVED_PROVIDER,
} from './constants';

const providersSelector = (state) => state.providers;

export const useProviders = {
  state: () => {
    const providers = useSelect(providersSelector);
    return { providers };
  },
  actions: () => {
    return {
      getOrganizations: useAction(getOrganizations, {
        saga: useAsync(GET_ORGANIZATIONS),
      }),
      getTaxIdNumbers: useAction(getTaxIdNumbers, {
        saga: useAsync(GET_TAX_ID_NUMBERS),
      }),
      getProviders: useAction(getProviders, {
        saga: useAsync(GET_PROVIDERS),
      }),
      getSavedProvider: useAction(getSavedProvider, {
        saga: useAsync(GET_SAVED_PROVIDER),
      }),
      postSavedProvider: useAction(postSavedProvider, {
        saga: useAsync(POST_SAVED_PROVIDER),
      }),
    };
  },
};
